import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditSessionNotification = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Change user access to a Restricted Page'
      fields={fields}
      apiPath={`admin/session_pages/${props.params.sessionRestrictedPageId}`}
      successRedirectPath='/write-now/session_restricted_pages'
      buildMenuItems={menuItems}
    />
  )
}

export default EditSessionNotification
